import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import moment from "moment";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { buildSheetFromConfig, CONSTANT_NAME, tableConfig } from "./config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { mapToObjectDDL } from "../../../../../common/mapper";
import { HttpStatus } from "../../../../../common/Constants";
import Api from "../../../../../../Services/Api";
import { saveAs } from "file-saver";
export default class LaporanServiceMTD extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      mechanicName: null,
      mechanicOptions: [],
    };
  }

  componentDidMount() {
    this.fetchDataMechanic();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.fetchDataMechanic();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchDataMechanic = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getMechanicForDropDownListDashboard,
      setError: setError,
      menuName: "Dashboard Mekanik SA - Laporan Servis Harian by Mekanik",
      args: [kodeCabang?.value],
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res?.data?.data?.map((item) =>
        mapToObjectDDL(item.mechanicName, item.idEmployee),
      );
      this.setState(
        {
          mechanicOptions: data,
          mechanicName: data[0],
        },
        () => {
          this.fetchData();
        },
      );
    }
  };

  fetchData = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year, month, mechanicName } = this.state;

    if (!kodeCabang) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanServisMTDH23,
      setError: setError,
      menuName: "Dashboard Mekanik SA - Laporan Service MTD",
      args: {
        listCabang: [kodeCabang?.value],
        year: year?.value,
        month: month?.value,
        mechanicEmployeeId: mechanicName?.value,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || {};
      this.setState({
        dataTable: Object.entries(data).map(([key, value]) => ({
          name: CONSTANT_NAME[key] || "",
          ...value,
        })),
      });
    }
  };

  handlePrint = async () => {
    const { onTriggerLoading, setError } = this.props;
    const { dataTable } = this.state;

    const title = "Dashboard Mekanik SA Laporan Servis MTD";
    const fileName = title.replace(/\s+/g, "_");

    const reqBody = {
      filename: fileName,
      sheets: [
        buildSheetFromConfig({
          title,
          config: tableConfig,
          data: dataTable,
        }),
      ],
    };

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError,
      menuName: `Dashboard Kabeng Keatas - ${title}`,
      args: reqBody,
    });

    onTriggerLoading();

    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${fileName}.xlsx`);
    }
  };

  render() {
    const { month, year, mechanicName, mechanicOptions, dataTable } =
      this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_bulan"
            box="search"
            name="month"
            containerclassname="width width-150px"
            placeholder="Bulan"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleDDL
            id="select_mechanic"
            box="search"
            name="mechanicName"
            containerclassname="width width-250px"
            placeholder="Nama Mekanik"
            options={mechanicOptions}
            value={mechanicName}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={this.handleSearch}
          />
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
